/**
 * TanStack Router: /available-budget
 *
 * This route file was auto-generated by the route generation script.
 * Component: AvailableBudgetPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import AvailableBudgetPage from '@/app/available-budget/page'

/**
 * Route: /available-budget
 * Layout: _auth (authenticated)
 * Component: AvailableBudgetPage
 */
export const Route = createFileRoute('/_auth/available-budget')({
  component: AvailableBudgetPage,
})
